import axios from 'axios';
import BASE_URL from '../../../BASE_URL';

const RecuperarSenha =
  // eslint-disable-next-line no-unused-vars


    (
      ydata,
      navigate,
      counter,
      setCounter,
      ShowNotification,
      message,
      errorMessage
    ) =>
    async (dispatch) => {
      await axios
        .post(`${BASE_URL}/utilizadores/recuperarsenha`, { ydata })
        .then(() => {
          dispatch(ShowNotification(message));
          setCounter({
            ...counter,
            running: true,
          });
        })

        .catch((err) => {
          if (err.response && err.response.status === 403) {
            const warningMessage = {
              isOpen: true,
              message: err.response.data.message,
              type: 'warning',
            };

            dispatch(ShowNotification(warningMessage));
          } else {
            // Inclui falhas sem resposta (rede, CORS, timeout), que antes eram silenciosas.
            dispatch(ShowNotification(errorMessage));
          }
        });
    };
export default RecuperarSenha;
